// extracted by mini-css-extract-plugin
module.exports = {"login":"style_login__oWwKC","fullscreen":"style_fullscreen__eeVYg","windowed":"style_windowed__C9tkv","header":"style_header__3qsNC","logo":"style_logo__2gz02"};